import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-modul-lib',
  template: `
    <p>
      modul-lib works!
    </p>
  `,
  styles: []
})
export class ModulLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
